var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.056 1c.215 0 .482.051.684.254.203.202.26.475.26.69v9.823c0 .215-.057.482-.26.684-.202.203-.47.26-.684.26H12.05c-.1.002-.025-3.465 0-5.78-2.712-.046-5.763-.209-5.761-.312V1.944c0-.215.057-.488.26-.69C6.75 1.05 7.018 1 7.233 1h9.823zm-5.29 5.289c.514 0 .945.43.945.944v9.823a.955.955 0 0 1-.944.944H1.944A.955.955 0 0 1 1 17.056V7.233c0-.513.431-.944.944-.944h9.823zm-.188 1.133H2.133v9.445h9.445V7.422z",
    fill: "#90A9C0",
    fillRule: "nonzero",
    stroke: "#90A9C0",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.9dfee47dc106b65c0be44f0435fea8f4.svg";
export { ForwardRef as ReactComponent };